import React from 'react';
import { Box, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WizardFormData } from '../schemas';
import { WizardAutocompleteField } from './WizardAutocompleteField';
import { useWizardData } from '../hooks/useWizardData';
import LinkPreview from './LinkPreview';

interface OfferFormProps {
  entryDomains: any[];
  redirectDomains: any[];
}

function OfferForm({ entryDomains, redirectDomains }: OfferFormProps) {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<WizardFormData>();

  const { domains } = useWizardData();
  const uid = watch('offerUniqueId');

  const entryDomainId = watch('entryDomainId');
  const redirectDomainId = watch('redirectDomainId');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <TextField fullWidth label="Offer Name" {...register('offerName')} error={!!errors.offerName} helperText={errors.offerName?.message || ''} required />

      <TextField
        fullWidth
        label="Offer Link"
        {...register('offerLink')}
        error={!!errors.offerLink}
        helperText={errors.offerLink?.message || 'Enter the URL where users will be redirected'}
        required
      />

      <WizardAutocompleteField
        label="Entry Domain"
        name="entryDomainId"
        options={entryDomains.map((domain) => ({
          id: domain._id,
          label: domain.domainName,
        }))}
        helperText={errors.entryDomainId?.message || ''}
        textFieldProps={{ required: true }}
      />

      <LinkPreview domains={domains} domainId={entryDomainId} uniqueId={uid} title="Entry Domain Link" />

      <WizardAutocompleteField
        label="Redirect Domain"
        name="redirectDomainId"
        options={redirectDomains.map((domain) => ({
          id: domain._id,
          label: domain.domainName,
        }))}
        helperText={errors.redirectDomainId?.message || ''}
        textFieldProps={{ required: true }}
      />

      <LinkPreview domains={domains} domainId={redirectDomainId} uniqueId={uid} title="Redirect Domain Link" />
    </Box>
  );
}

export default OfferForm;
